import { addPet, createQuoteFromScratch, deletePet } from "@/shared/http"
import { verifyTurnstileToken } from "@/shared/http/turnstile"
import { useTurnstile } from "@/shared/components/Turnstile/use-turnstile"
import { SyncBackBody, SyncBackPet } from "@/shared/types/lead-api-types"
import { useMutation } from "@tanstack/react-query"

export const useCreateQuoteFromScratch = () => {
  const { getToken, resetToken } = useTurnstile()

  return useMutation({
    mutationKey: ["create-quote-from-scratch"],
    mutationFn: async ({ quote }: { quote: Partial<SyncBackBody> }) => {
      await verifyTurnstileToken(getToken(), resetToken)
      const response = await createQuoteFromScratch(quote)
      return response
    },
    retry: 0,
  })
}

export const useAddPet = () => {
  return useMutation({
    mutationKey: ["add-pet"],
    mutationFn: async ({ quoteId, pet }: { quoteId?: string; pet?: SyncBackPet }) => {
      const response = await addPet(quoteId, pet)

      return response
    },
    retry: 0,
  })
}

export const useDeletePet = () => {
  return useMutation({
    mutationKey: ["delete-pet"],
    mutationFn: async ({ quoteId, petIndex }: { quoteId: string; petIndex: number }) => {
      const response = await deletePet(quoteId, petIndex)

      return response
    },
    retry: 0,
  })
}
